var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,21h2v5a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V6A3,3,0,0,1,5,3H24a3,3,0,0,1,3,3V7.15H25V6a1,1,0,0,0-1-1H5A1,1,0,0,0,4,6V26a1,1,0,0,0,1,1H24a1,1,0,0,0,1-1Zm5.34-8.84a3,3,0,0,1-.88,2.13l-1.59,1.58L20.3,23.45a1,1,0,0,1-.57.28l-3.3.48h-.15a1,1,0,0,1-.7-.3,1,1,0,0,1-.29-.85l.48-3.3a1,1,0,0,1,.28-.57l7.58-7.57L25.21,10a3.09,3.09,0,0,1,4.25,0A3,3,0,0,1,30.34,12.16Zm-4.59,3-1.41-1.41L17.7,20.38,17.46,22l1.66-.24Zm2.59-3a1,1,0,0,0-.3-.7,1,1,0,0,0-1.41,0l-.88.88,1.41,1.41.88-.88A1,1,0,0,0,28.34,12.16ZM14,24V22H7v2Z",
    "data-name": "57  Write, Basic, Essential, Pencil"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/Write.cab396d62602fcefbd19668a79a5b8db.svg";
export { ForwardRef as ReactComponent };